import { C as A } from "./component-CAYPdBLR.js";
const b = {
  childrenOnly: !0,
  reject(e, t) {
    return !!(
      (t.nodeType === Node.TEXT_NODE && t.nodeValue?.trim() === "") ||
      (t instanceof HTMLTemplateElement &&
        t.shadowRootMode === "open" &&
        e.parentElement &&
        t.parentElement &&
        e.parentElement.tagName === t.parentElement.tagName &&
        e.parentElement?.shadowRoot !== null &&
        e.parentElement?.shadowRoot !== void 0) ||
      (t.nodeType === Node.COMMENT_NODE && t.nodeValue === "shopify:rendered_by_section_api")
    );
  },
  onBeforeUpdate(e, t) {
    if (e instanceof Element && t instanceof Element) {
      const i = [
        "product-grid-view",
        "data-current-checked",
        "data-previous-checked",
        "cart-summary-sticky",
      ];
      for (const r of i) {
        const f = e.getAttribute(r),
          s = t.getAttribute(r);
        f && f !== s && t.setAttribute(r, f);
      }
      const n = ["floating-panel-component", "fieldset.variant-option"],
        a = ["account-popover"];
      for (const r of n)
        if (e.matches(r) && t.matches(r)) {
          const f = e.getAttribute("style");
          f && t.setAttribute("style", f);
        }
      for (const r of a)
        if (e.id === r && t.id === r) {
          const f = e.getAttribute("style");
          f && t.setAttribute("style", f);
        }
      e instanceof HTMLElement &&
        t instanceof HTMLElement &&
        e.style.viewTransitionName &&
        (t.style.viewTransitionName = e.style.viewTransitionName);
    }
  },
  onAfterUpdate(e) {
    e instanceof A && queueMicrotask(() => e.updatedCallback());
  },
};
function V(e, t, i = b) {
  if (!e || !t) throw new Error("Both oldTree and newTree must be provided");
  if (typeof t == "string") {
    const n = new DOMParser().parseFromString(t, "text/html").body.firstChild;
    if (!n) throw new Error("newTree string is not valid HTML");
    t = n;
  }
  if (i.childrenOnly) return (T(t, e, i), e);
  if (t.nodeType === 11)
    throw new Error("newTree should have one root node (not a DocumentFragment)");
  return m(t, e, i);
}
function m(e, t, i) {
  if (!t) return e;
  if (!e || e.isSameNode?.(t)) return t;
  if (e.nodeType !== t.nodeType) return e;
  if (e instanceof Element && t instanceof Element) {
    if (t.tagName === "SHOPIFY-ACCELERATED-CHECKOUT-CART") return t;
    if (e.tagName !== t.tagName) return e;
    const n = c(e, i),
      a = c(t, i);
    if (n && a && n !== a) return e;
  }
  return (
    (t instanceof Element &&
      t.hasAttribute("data-skip-node-update") &&
      e instanceof Element &&
      e.hasAttribute("data-skip-node-update")) ||
      y(e, t, i),
    T(e, t, i),
    i.onAfterUpdate?.(e),
    t
  );
}
function y(e, t, i) {
  if (
    (i.onBeforeUpdate?.(t, e),
    ((e instanceof HTMLDetailsElement && t instanceof HTMLDetailsElement) ||
      (e instanceof HTMLDialogElement && t instanceof HTMLDialogElement)) &&
      (e.hasAttribute("declarative-open") || (e.open = t.open)),
    t instanceof HTMLElement && e instanceof HTMLElement)
  )
    for (const n of ["slot", "sizes"]) {
      const a = t.getAttribute(n),
        r = e.getAttribute(n);
      a !== r && (a == null ? e.removeAttribute(n) : e.setAttribute(n, a));
    }
  (e instanceof Element && t instanceof Element
    ? t.isEqualNode(e) || v(e, t)
    : (e instanceof Text || e instanceof Comment) &&
      t.nodeValue !== e.nodeValue &&
      (t.nodeValue = e.nodeValue),
    e instanceof HTMLInputElement && t instanceof HTMLInputElement
      ? g(e, t)
      : e instanceof HTMLOptionElement && t instanceof HTMLOptionElement
        ? E(e, t, "selected")
        : e instanceof HTMLTextAreaElement && t instanceof HTMLTextAreaElement && M(e, t));
}
function c(e, t) {
  return t?.getNodeKey?.(e) ?? (e instanceof Element ? e.id : void 0);
}
function E(e, t, i) {
  e[i] !== t[i] &&
    ((t[i] = e[i]),
    e[i] !== null && e[i] !== void 0 ? t.setAttribute(i, "") : t.removeAttribute(i));
}
function v(e, t) {
  const i = t.attributes,
    n = e.attributes;
  for (const a of Array.from(n)) {
    const { name: r, namespaceURI: f, value: s } = a,
      u = a.localName || r;
    ((r === "src" || r === "href" || r === "srcset" || r === "poster") &&
      t.getAttribute(r) === s) ||
      (f
        ? t.getAttributeNS(f, u) !== s && t.setAttributeNS(f, u, s)
        : t.hasAttribute(r)
          ? t.getAttribute(r) !== s &&
            (s === "null" || s === "undefined" ? t.removeAttribute(r) : t.setAttribute(r, s))
          : t.setAttribute(r, s));
  }
  for (const a of Array.from(i)) {
    if (a.specified === !1) continue;
    const { name: r, namespaceURI: f } = a,
      s = a.localName || r;
    f
      ? e.hasAttributeNS(f, s) || t.removeAttributeNS(f, s)
      : e.hasAttribute(r) || t.removeAttribute(r);
  }
}
function g(e, t) {
  const i = e.value;
  (E(e, t, "checked"),
    E(e, t, "disabled"),
    e.indeterminate !== t.indeterminate && (t.indeterminate = e.indeterminate),
    t.type !== "file" &&
      (i !== t.value && (t.setAttribute("value", i), (t.value = i)),
      i === "null" && ((t.value = ""), t.removeAttribute("value")),
      e.hasAttributeNS(null, "value")
        ? t.type === "range" && (t.value = i)
        : t.removeAttribute("value")));
}
function M(e, t) {
  const i = e.value;
  i !== t.value && (t.value = i);
  const n = t.firstChild;
  if (n?.nodeType === Node.TEXT_NODE) {
    if (i === "" && n.nodeValue === t.placeholder) return;
    n.nodeValue = i;
  }
}
function T(e, t, i) {
  if (
    t instanceof Element &&
    t.hasAttribute("data-skip-subtree-update") &&
    e instanceof Element &&
    e.hasAttribute("data-skip-subtree-update")
  )
    return;
  let n,
    a,
    r,
    f,
    s = 0;
  for (let u = 0; (n = t.childNodes[u]), (a = e.childNodes[u - s]), !(!n && !a); u++) {
    if (!a) {
      (n && t.removeChild(n), u--);
      continue;
    }
    if (!n) {
      (t.appendChild(a), s++);
      continue;
    }
    if (h(a, n, i)) {
      ((r = m(a, n, i)), r !== n && (t.replaceChild(r, n), s++));
      continue;
    }
    if (i.reject?.(n, a)) {
      (e.removeChild(a), u--);
      continue;
    }
    f = null;
    for (let l = u; l < t.childNodes.length; l++) {
      const p = t.childNodes[l];
      if (p && h(p, a, i)) {
        f = p;
        break;
      }
    }
    f
      ? ((r = m(a, f, i)), r !== f && s++, t.insertBefore(r, n))
      : !c(a, i) && !c(n, i)
        ? ((r = m(a, n, i)), r !== n && (t.replaceChild(r, n), s++))
        : (t.insertBefore(a, n), s++);
  }
}
function h(e, t, i) {
  if (e.nodeType !== t.nodeType) return !1;
  if (e.nodeType === Node.ELEMENT_NODE) {
    if (e instanceof Element && t instanceof Element && e.tagName !== t.tagName) return !1;
    const n = c(e, i),
      a = c(t, i);
    if (n && a && n !== a) return !1;
  }
  return e.nodeType === Node.TEXT_NODE && t.nodeType === Node.TEXT_NODE
    ? e.nodeValue?.trim() === t.nodeValue?.trim()
    : e.nodeType === Node.COMMENT_NODE && t.nodeType === Node.COMMENT_NODE
      ? e.nodeValue === t.nodeValue
      : !0;
}
export { V as m };
